import NoticeSectionImplementation from '../implementation/sections/NoticeSection';
import { ComponentProps } from '@components/strapi/DynamicZoneComponent';
import {
  StrapiNoticeSectionDTO,
  NoticeSectionDTO,
} from '@lib/strapi/dtos/components/sections/noticeSection.dto';

const NoticeSection = (props: ComponentProps<NoticeSectionDTO>) => {
  return <NoticeSectionImplementation {...props}></NoticeSectionImplementation>;
};

export default NoticeSection;
